import { BalancesProps } from './types';
import { AutoTextSize } from '../../Helper/utils/autoTextSizeUtils';
import { StyledBalancesLayout } from './style';

export const BalancesLayout = ({ children }: BalancesProps) => {
    return (
        <StyledBalancesLayout>
            <div className="balanceLayoutContainer">
                <AutoTextSize
                    mode={'box'}
                    maxFontSizePx={14}
                    minFontSizePx={10}
                >
                    {children}
                </AutoTextSize>
            </div>
        </StyledBalancesLayout>
    );
};
